import { useTranslation } from 'react-i18next'
import { LoadingBlock } from '../components/Spinner'

/**
 * The console's canonical no-text spinner while a paged list fetches a page:
 * roomy while the list is still empty, compact under rows already shown.
 */
export function ListLoading({ loading, empty }: { loading: boolean; empty: boolean }) {
  const { t } = useTranslation('library')
  if (!loading) return null
  return <LoadingBlock pad={empty ? '48px 0' : '16px 0'} label={t('loading')} />
}
